<template lang="pug">
.div
	.div(style="position:relative;display:block;text-align:center;padding:5px;")
		button.btn.btn-sm(:class="(verTipo === 'programados') ? 'btn-primary' : 'btn-default'" @click="verTipo = 'programados'")
			Ver programación
		.button.btn.btn-sm(:class="(verTipo === 'emitidos') ? 'btn-primary' : 'btn-default'" @click="verTipo = 'emitidos'")
			Ver emisión
		.button.btn.btn-sm.btn-success(@click="descargar()")
			span.fa.fa-download
			Descargar
	table.table.table-condensed.striped.text-left(v-if="verTipo === 'programados' && auditando")
		thead.bg-dark.text-white
			tr
				th Programada
				th Emitida
				th Día de emisión
		tbody(v-for="(data, emisora) in detalles" :key="emisora")
			tr.bg-light(style="font-weight:bolder;")
				td
					span.fa.fa-info.mr-2
					|{{emisora}}
					.badge.badge-info.p-2.text-uppercase.pull-right(style="font-size:0.9em;")|{{data.items.length}} programados
				td colspan="2"
					.badge.badge-warning.p-2.text-uppercase(style="font-size:0.9em;")|{{data.emitidos}} emitidos
			tr(v-for="item in data.items" :key="item.ID_programacion" :class="(!item.emitido && item.fecha < new Date().getTime()) ? 'bg-danger text-white' : ''")
				td
					|{{new Date(item.fecha).toLocaleString()}}
				td
					span.fa.fa-check(v-if="item.emitido")
					span.fa.fa-ban(v-if="!item.emitido && item.fecha < new Date().getTime()")
					span.fa.fa-clock-o(v-if="!item.emitido && item.fecha >= new Date().getTime()")
				td
					span(v-if="item.emitido")
						|{{new Date(item.emitido.fecha).toLocaleString()}}
		tbody(v-if="Object.keys(detalles).length === 0 && auditando")
			tr
				td.text-center(colspan="3")
					.alert.alert-danger
						h3 No hay información de programación de este fichero
	table.table.table-condensed.striped.text-left(v-if="verTipo === 'emitidos' && auditando")
		thead.bg-dark.text-white
			tr
				th Día de emisión
		tbody(v-for="(items, emisora) in detallesEmitidos" :key="emisora")
			tr.bg-light(style="font-weight:bolder;")
				td
					span.fa.fa-info.mr-2
					|{{emisora}}
					.badge.badge-success.p-2.text-uppercase.pull-right(style="font-size:0.9em;")|{{items.length}} emitidos
			tr(v-for="item in items" :key="item.ID_programacion")
				td
					span
						|{{new Date(item.fecha).toLocaleString()}}
			tr(v-if="Object.keys(detallesEmitidos).length === 0 && auditando")
				td
					.alert.alert-danger
						h3 No hay información de radiación de este fichero
	modal-descargar(v-if="descargando" :idfichero="idfichero" :idversion="idversion" @cerrar="descargando = false")
</template>

<script>

import ModalDescargar from './modal-descargar'
import API from '../../services/api'

export default {
	name: 'detalles',
	props: ['idfichero', 'idversion'],
	components: {
		'modal-descargar': ModalDescargar
	},
	watch: {
		idfichero: function (nuevo) {
			if (nuevo) {
				this.auditar()
			}
		}
	},

	data: function () {
		return {
			radiacion: {
				emitidos: [],
				programados: []
			},
			auditando: false,
			verTipo: 'programados',
			descargando: false
		}
	},

	created: function () {
		this.auditar()
	},

	computed: {
		detalles () {
			if (this.radiacion.programados.length === 0) {
				return []
			}

			const arr = {}

			for (let emisora in this.radiacion.programados) {
				const items = this.radiacion.programados[emisora]
				arr[emisora] = (arr[emisora]) ? arr[emisora] : {items: [], emitidos: 0}

				for (let i = 0; i < items.length; i++) {
					const item = items[i]
					item.emisora = emisora

					const idProg = items[i].ID_programacion

					for (let emi in this.radiacion.emitidos) {
						const emis = this.radiacion.emitidos[emi]

						for (let e = 0; e < emis.length; e++) {
							if (idProg === emis[e].ID_programacion) {
								item.emitido = emis[e]
								arr[emisora].emitidos++
							}
						}
					}

					arr[emisora].items.push(item)
				}
			}

			return arr
		},
		detallesEmitidos () {
			if (this.radiacion.emitidos.length === 0) {
				return []
			}

			const arr = {}

			for (let emisora in this.radiacion.emitidos) {
				arr[emisora] = (!arr[emisora]) ? [] : arr[emisora]
				arr[emisora] = arr[emisora].concat(this.radiacion.emitidos[emisora])
			}

			return arr
		}
	},

	methods: {
		auditar () {
			API.getAuditor(this.idfichero)
				.then(res => {
					this.auditando = this.idfichero
					const emitidos = res.data.emitidos

					const e = {}

					for (let i = 0; i < emitidos.length; i++) {
						const idProgramacion = emitidos[i].ID_programacion
						const emisora = emitidos[i].emisora_nombre

						e[emisora] = (e[emisora]) ? e[emisora] : []

						e[emisora].push({
							fecha: emitidos[i].fecha_unix * 1000,
							ID_programacion: idProgramacion
						})
					}

					this.radiacion.emitidos = e
				})
				.catch(e => {
					this.$store.commit('alertas/alert', {
						titulo: 'Error',
						mensaje: e.response.data.error
					})
				})

			// AHora la programación
			API.getProgramacion(this.idfichero)
				.then(res => {
					const programados = res.data.programados
					const prog = {}

					for (let i = 0; i < programados.length; i++) {
						const emisora = programados[i].emisora_descripcion

						prog[emisora] = (prog[emisora]) ? prog[emisora] : []
						prog[emisora].push({
							fecha: programados[i].unix_inicio * 1000,
							emisora: emisora,
							ID_programacion: programados[i].programacion_ID
						})
					}
					this.radiacion.programados = prog
				})
				.catch(e => {
					this.$store.commit('alertas/alert', {
						titulo: 'Error',
						mensaje: e.response.data.error
					})
				})
		},

		descargar () {
			this.descargando = true
		}
	}
}
</script>



// WEBPACK FOOTER //
// src/modulos/produccion/vue/components/auditor/detalles.vue